import { Link } from "react-router-dom";

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-tiktok-fill", label: "抖音" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">邻居的妻子</span>
          </div>
          <p className="text-sm leading-relaxed text-background-300/90">
            专注影视剧集与剧情介绍的内容平台，为你整理清晰的作品资料、详细的剧情脉络与最新更新信息。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">
            <Link to="/category" className="hover:text-accent-400 cursor-pointer">影视导航</Link>
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/category" className="hover:text-accent-400 transition-colors cursor-pointer">影视分类</Link></li>
            <li><Link to="/search" className="hover:text-accent-400 transition-colors cursor-pointer">搜索影视</Link></li>
            <li><Link to="/detail/neighbor-wife" className="hover:text-accent-400 transition-colors cursor-pointer">邻居的妻子专题</Link></li>
            <li><Link to="/category" className="hover:text-accent-400 transition-colors cursor-pointer">最新更新</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">
            <Link to="/about" className="hover:text-accent-400 cursor-pointer">关于与帮助</Link>
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
            <li><Link to="/contact" className="hover:text-accent-400 transition-colors cursor-pointer">联系我们</Link></li>
            <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">版权声明</Link></li>
            <li><Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">免责声明</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-background-50 text-sm font-semibold mb-4">关注我们</h4>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <span
                key={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                title={s.label}
              >
                <i className={`${s.icon} text-lg`}></i>
              </span>
            ))}
          </div>
          <p className="mt-4 text-xs text-background-400 leading-relaxed">
            本站内容仅作展示与剧情介绍，不提供在线播放与下载服务。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800/70">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-400">
          <p>© 2026 邻居的妻子影视大全 · 影视内容展示平台</p>
          <p>剧情资料整理自公开信息，仅供学习交流使用</p>
        </div>
      </div>
    </footer>
  );
}